export const legalTypes = [
  'Data Subscription Agreement - Public',
  'DDQ',
  'Privacy Policy',
  'DPA',
  'CCPA Policy',
  'GDPR Policy',
]
